import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { MatSnackBar } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  protected defaultController = `https://api.${environment.baseUrl}/api/`;
  protected slug = 'feedback';
  constructor(public http: HttpClient, private snackBar: MatSnackBar) {
  }

  public addFeedback(payload: any): Observable<any> {
    return this.http.post(`${this.defaultController}${this.slug}`, payload).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err38', {
          duration: 5000,
        });
      }));
  }

  public getFeedbacks(): Observable<any> {
    return this.http.get(`${this.defaultController}${this.slug}`);
  }

  public updateFeedback(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.defaultController}${this.slug}/${id}`, payload).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err37', {
          duration: 5000,
        });
      }));
  }

  public deleteFeedback(id: string): Observable<any> {
    return this.http.delete(`${this.defaultController}${this.slug}/${id}`).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err36', {
          duration: 5000,
        });
      }));
  }
}
